/** A moment as the reader's language writes it: «20 ott 2026, 09:30». */
export function formatWhen(iso: string, language: string | undefined): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(language ?? 'it', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(date);
}

/** A day, without the hour. */
export function formatDay(iso: string, language: string | undefined): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return new Intl.DateTimeFormat(language ?? 'it', { dateStyle: 'long' }).format(date);
}

/** The API's text as plain paragraphs: split on blank lines, never parsed as markup. */
export function paragraphsOf(text: string): string[] {
  return text
    .split(/\n{2,}/)
    .map((part) => part.trim())
    .filter((part) => part !== '');
}

/** The recipient's name; the API leaves it null when the account is gone, then the id stands in. */
export function recipientName(item: {
  recipient: { displayName: string } | null;
  message: { userId: string };
}): string {
  return item.recipient?.displayName ?? item.message.userId;
}

/** A user id for a table cell: the log carries ids, not names, so a UUID is cut short. */
export function shortId(id: string): string {
  return /^[0-9a-f]{8}-[0-9a-f-]{27}$/i.test(id) ? id.slice(0, 8) : id;
}
